import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { TimezoneModule } from '../timezone/timezone.module';
import { DeliveryStatusTrackingMainInfoComponent } from './delivery-status-tracking-main-info.component';
import { DeviationTypeModule } from '../deviation-type';
import { InfoFieldModule } from '../info-field/info-field.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DeliveryStatusTrackingMainInfoComponent],
  imports: [
    CommonModule,
    IntrackFeatureModule,
    TranslateModule,
    TimezoneModule,
    InfoFieldModule,
    DeviationTypeModule,
    SvgIconModule,
  ],
  exports: [DeliveryStatusTrackingMainInfoComponent],
})
export class DeliveryStatusTrackingMainInfoModule {}
